import React from 'react'
import styled from 'styled-components'

import Modal from 'components/Modal'

import { color } from 'styles/colors'

type Props = {
  isDisplayed: boolean
  closeCallback: () => void
}

const FAQ = ({ isDisplayed, closeCallback }: Props) => {
  return (
    <Modal title="Faq's" isDisplayed={isDisplayed} closeCallback={closeCallback} variant="sm">
      <S.dl>
        <S.dt>How many days are available in the run time history graphs?</S.dt>
        <S.dd>Up to 30 days.</S.dd>

        <S.dt>Why does heating/cooling system continue to operate when the target set point has been met?</S.dt>
        <S.dd>The 850 and 824 utilize advanced control schemes designed to cycle around set point in a manner
          which optimizes comfort and improves system reliability… for details see the Advanced Operation section
          in the 824 and 850 Installation Guide.
        </S.dd>

        <S.dt>Why does the run time history graph sometimes have gaps in the data?</S.dt>
        <S.dd>Gaps typically appear whenever the network connection is lost for more than 7 minutes and also
          whenever an invalid value was received.
        </S.dd>

        <S.dt>Why does the indoor temperature appear to rise in the beginning or end of a cycle for some systems?</S.dt>
        <S.dd>During the “Smart Optimization” routine the control determined that the air flow around the control
          affected the sensed indoor temperature. Smart Optimization applies a learned temperature offset
          during a call for capacity.
        </S.dd>

        <S.dt>What would cause the cooling system to cycle below set point for extended periods of time?</S.dt>
        <S.dd>Overcooling has been enabled on the control and the indoor humidity is above the cooling target humidity.</S.dd>

        <S.dt>Why does the indoor temperature graph appear flat at times even though the heating/cooling system is operating?</S.dt>
        <S.dd>The graphs only depict indoor temperature changes greater than quarter of degree increments.</S.dd>

        <S.dt>Why does the indoor temperature oscillate up and down when the heating/cooling system is idle?</S.dt>
        <S.dd>The graphs only depict indoor temperature changes greater than quarter of degree increments.</S.dd>

        <S.dt>Why does the indoor temperature oscillate up and down when the heating/cooling system is idle?</S.dt>
        <S.dd>The “Fan Mode” is set to “Circulate” and the air flow is cooling the control. Smart Optimization only offsets
          the sensed indoor temperature during heating/cooling operation.
        </S.dd>

        <S.dt>What are the different colored triangles that occasionally appear on the bottom of the graphs? </S.dt>
        <S.dd>The red, yellow, and green triangles indicate a system alert has been asserted at the time indicated on the graph.
          The color indicates the severity of the alert:  Red = Critical, Yellow = Major, and Green = Normal.
        </S.dd>
        <S.dd>The purple triangles indicate an SDA alert has been asserted based on algorithms that run periodically in the cloud.
          These are independent of the system alerts triggered within the equipment. The color indicates the severity of the
          alert: Solid Purple = Major, Empty Purple = Normal.
        </S.dd>
      </S.dl>
    </Modal>
  )
}

export default FAQ

const S = {
  dl: styled.dl`
    padding: 1.2em;
`,
  dd: styled.dd`
    margin-bottom: 1.2em;
    color: ${color('secondaryText')};
    line-height: 1.3;
    font-weight: bold;
`,
  dt: styled.dt`
    line-height: 1.3;
    margin-bottom: 0.3rem;
    color: ${color('primaryText')};
`
}
